import '@department-of-veterans-affairs/platform-polyfills';
import './sass/survivors-benefits.scss';

import { startAppFromIndex } from '@department-of-veterans-affairs/platform-startup/exports';

import { createFormRoutes } from './routes';
import reducer from './reducers';
import manifest from './manifest.json';

startAppFromIndex({
  entryName: manifest.entryName,
  url: manifest.rootUrl,
  reducer,
  createRoutesWithStore: createFormRoutes,
});
